import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CrownIcon, CheckCircleIcon, ArrowRightIcon, ChevronRightIcon, ShieldCheckIcon, ClockIcon, UsersIcon, StarIcon, BriefcaseIcon, EyeOffIcon, TrendingUpIcon, ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { ContactForm } from '../../components/ContactForm';
function HeroSection() {
  return <section className="relative pt-20 lg:pt-24 pb-20 overflow-hidden bg-navy-900" data-id="element-940">
      <div className="absolute inset-0" data-id="element-941">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-500/8 blur-3xl" data-id="element-942" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-cyan-500/6 blur-3xl" data-id="element-943" />
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,1) 1px, transparent 0)`,
        backgroundSize: '32px 32px'
      }} data-id="element-944" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-945">
        <motion.nav initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex items-center gap-1.5 text-sm text-navy-400 mb-10" data-id="element-946">
          <Link to="/" className="hover:text-primary-400 transition-colors" data-id="element-947">
            Головна
          </Link>
          <ChevronRightIcon className="w-3.5 h-3.5" data-id="element-948" />
          <Link to="/#services" className="hover:text-primary-400 transition-colors" data-id="element-949">
            Послуги
          </Link>
          <ChevronRightIcon className="w-3.5 h-3.5" data-id="element-950" />
          <span className="text-navy-300" data-id="element-951">Executive Search</span>
        </motion.nav>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-952">
          <div data-id="element-953">
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.05
          }} className="flex items-center gap-3 mb-6" data-id="element-954">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-400 to-primary-600 text-white shadow-xl shadow-primary-500/30" data-id="element-955">
                <CrownIcon className="w-6 h-6" data-id="element-956" />
              </div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary-500/20 text-primary-300 text-xs font-semibold rounded-full border border-primary-500/20" data-id="element-957">
                Ключова спеціалізація
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.55,
            delay: 0.1
          }} className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.08]" data-id="element-958">
              Executive Search{' '}
              <span className="text-primary-400" data-id="element-959">(C‑level)</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.18
          }} className="mt-6 text-xl text-navy-300 leading-relaxed" data-id="element-960">
              Пошук та підбір топ‑менеджерів: CEO, COO, CFO, CTO, CMO та інших
              керівників вищої ланки. Глибоке розуміння ринку та конфіденційний
              підхід до кожного проєкту.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.25
          }} className="mt-8 flex flex-wrap gap-4" data-id="element-961">
              <a href="#contact" className="inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-navy-900 bg-white rounded-xl hover:bg-navy-50 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-962">
                Залишити заявку
                <ArrowRightIcon className="w-4 h-4" data-id="element-963" />
              </a>
              <a href="#process" className="inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-white border border-white/20 rounded-xl hover:bg-white/10 transition-all" data-id="element-964">
                Як ми працюємо
              </a>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-2 gap-4" data-id="element-965">
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-966">
              <div className="text-4xl font-extrabold text-white" data-id="element-967">14</div>
              <div className="text-sm text-navy-400 mt-1" data-id="element-968">
                днів у середньому
              </div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-969">
              <div className="text-4xl font-extrabold text-primary-400" data-id="element-970">
                100%
              </div>
              <div className="text-sm text-navy-400 mt-1" data-id="element-971">гарантія заміни</div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-972">
              <div className="text-4xl font-extrabold text-white" data-id="element-973">500+</div>
              <div className="text-sm text-navy-400 mt-1" data-id="element-974">C‑level закрито</div>
            </div>
            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center" data-id="element-975">
              <div className="text-4xl font-extrabold text-primary-400" data-id="element-976">
                98%
              </div>
              <div className="text-sm text-navy-400 mt-1" data-id="element-977">
                успішність підбору
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
function WhatWeDoSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="py-20 lg:py-28 bg-white" ref={ref} data-id="element-978">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-979">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-980">
          <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-981">
            Що входить у послугу
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-982">
            Повний цикл пошуку топ‑менеджерів
          </h2>
          <p className="mt-4 text-lg text-navy-500 max-w-2xl mx-auto" data-id="element-983">
            Від формування профілю до виходу кандидата — ми супроводжуємо весь
            процес
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-984">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="p-7 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-985">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-986">
              <EyeOffIcon className="w-5 h-5" data-id="element-987" />
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2" data-id="element-988">
              Широкий пошук кандидатів
            </h3>
            <p className="text-navy-500 text-sm leading-relaxed" data-id="element-989">
              Використовуємо всі доступні джерела: власні 5 спільнот та 4 групи
              топ-менеджерів, відкриті майданчики, LinkedIn та прямий хантинг
              (за домовленістю).
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="p-7 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-990">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-991">
              <UsersIcon className="w-5 h-5" data-id="element-992" />
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2" data-id="element-993">
              Глибоке розуміння ринку
            </h3>
            <p className="text-navy-500 text-sm leading-relaxed" data-id="element-994">
              Знаємо ринок топ-менеджерів у ключових галузях — хто є, де працює,
              яка репутація. Це дозволяє швидко виходити на потрібних кандидатів
              без зайвих витрат часу.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="p-7 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-995">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-996">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-997" />
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2" data-id="element-998">
              Перевірка референсів
              <span className="ml-2 text-xs font-semibold text-primary-600 bg-primary-50 border border-primary-100 px-2 py-0.5 rounded-full" data-id="element-999">
                Опційно
              </span>
            </h3>
            <p className="text-navy-500 text-sm leading-relaxed" data-id="element-1000">
              Збір відгуків від колишніх роботодавців та колег — доступно як
              додаткова опція за окремою домовленістю.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="p-7 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-1001">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-1002">
              <StarIcon className="w-5 h-5" data-id="element-1003" />
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2" data-id="element-1004">
              Оцінка відповідності
            </h3>
            <p className="text-navy-500 text-sm leading-relaxed" data-id="element-1005">
              Проводимо інтерв'ю з кандидатами, оцінюємо відповідність вимогам
              позиції, досвід та мотивацію. Передаємо клієнту тих, хто реально
              підходить.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="p-7 rounded-2xl bg-navy-50/60 border border-navy-100" data-id="element-1006">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-white flex items-center justify-center mb-5 shadow-lg shadow-primary-500/20" data-id="element-1007">
              <BriefcaseIcon className="w-5 h-5" data-id="element-1008" />
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2" data-id="element-1009">
              Переговори та офер
            </h3>
            <p className="text-navy-500 text-sm leading-relaxed" data-id="element-1010">
              Допомагаємо структурувати компенсаційний пакет, ведемо переговори
              та супроводжуємо підписання контракту.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.35
        }} className="p-7 rounded-2xl bg-gradient-to-br from-primary-600 to-primary-700 border border-primary-500" data-id="element-1011">
            <div className="w-12 h-12 rounded-xl bg-white/20 text-white flex items-center justify-center mb-5" data-id="element-1012">
              <TrendingUpIcon className="w-5 h-5" data-id="element-1013" />
            </div>
            <h3 className="text-lg font-bold text-white mb-2" data-id="element-1014">
              Гарантія заміни
            </h3>
            <p className="text-primary-100 text-sm leading-relaxed" data-id="element-1015">
              Якщо кандидат не підійшов протягом випробувального терміну —
              підберемо заміну безкоштовно. Без зайвих питань.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}
function PositionsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const positions = ['CEO / Генеральний директор', 'COO / Операційний директор', 'CFO / Фінансовий директор', 'CTO / Технічний директор', 'CMO / Директор з маркетингу', 'CHRO / HR директор', 'CSO / Директор з продажів', 'CDO / Директор з цифрової трансформації', 'Board Member / Член ради директорів', 'Country Manager', 'VP of Engineering', 'VP of Product'];
  return <section className="py-20 lg:py-28 bg-navy-50/40" ref={ref} data-id="element-1016">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1017">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-1018">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6
        }} data-id="element-1019">
            <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-1020">
              Позиції
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-navy-900 tracking-tight" data-id="element-1021">
              Яких керівників ми підбираємо
            </h2>
            <p className="mt-4 text-lg text-navy-500 leading-relaxed" data-id="element-1022">
              Спеціалізуємося на пошуку топ‑менеджерів для компаній будь‑якого
              масштабу — від стартапів до міжнародних корпорацій.
            </p>
            <div className="mt-8 p-6 rounded-2xl bg-white border border-navy-100 shadow-sm" data-id="element-1023">
              <div className="flex items-start gap-3" data-id="element-1024">
                <CheckCircleIcon className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-1025" />
                <p className="text-navy-600 text-sm leading-relaxed" data-id="element-1026">
                  Середній досвід наших кандидатів —{' '}
                  <strong className="text-navy-900" data-id="element-1027">15+ років</strong> у галузі.
                  Ми не підбираємо «перспективних» — ми знаходимо тих, хто вже
                  довів свою ефективність.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1028">
            {positions.map((pos, i) => <motion.div key={pos} initial={{
            opacity: 0,
            y: 12
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.4,
            delay: 0.1 + i * 0.04
          }} className="flex items-center gap-2.5 p-3.5 rounded-xl bg-white border border-navy-100" data-id="element-1029">
                <div className="w-2 h-2 rounded-full bg-primary-500 flex-shrink-0" data-id="element-1030" />
                <span className="text-sm font-medium text-navy-700" data-id="element-1031">{pos}</span>
              </motion.div>)}
            <motion.div initial={{
            opacity: 0,
            y: 12
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.4,
            delay: 0.1 + positions.length * 0.04
          }} className="sm:col-span-2 flex items-center gap-2.5 p-3.5 rounded-xl bg-primary-50 border border-primary-100" data-id="element-1032">
              <div className="w-2 h-2 rounded-full bg-primary-400 flex-shrink-0" data-id="element-1033" />
              <span className="text-sm font-medium text-primary-700 italic" data-id="element-1034">
                Та інші позиції у цьому напрямку — зверніться, і ми підберемо
                потрібного спеціаліста
              </span>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}
function ProcessSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const steps = [{
    num: '01',
    title: 'Стратегічний бриф',
    desc: 'Глибоке занурення у бізнес клієнта. Вивчаємо стратегію, культуру, команду та очікування від нового керівника.',
    side: 'left'
  }, {
    num: '02',
    title: 'Формування лонг‑ліста',
    desc: 'Визначаємо пріоритетні джерела пошуку, формуємо список потенційних кандидатів з обґрунтуванням кожного.',
    side: 'right'
  }, {
    num: '03',
    title: 'Пошук та хантинг',
    desc: 'Активний пошук через власні спільноти, відкриті джерела та прямий вихід на цільових кандидатів.',
    side: 'left'
  }, {
    num: '04',
    title: "Інтерв'ю та відбір",
    desc: "Проводимо інтерв'ю з кандидатами, оцінюємо відповідність позиції та мотивацію. Відбираємо найкращих.",
    side: 'right'
  }, {
    num: '05',
    title: 'Презентація кандидатів',
    desc: "Представляємо фіналістів клієнту з детальними профілями. Організовуємо зустрічі та збираємо зворотний зв'язок.",
    side: 'left'
  }];
  return <section className="py-20 lg:py-28 bg-white" id="process" ref={ref} data-id="element-1035">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1036">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-1037">
          <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-1038">
            Процес
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-1039">
            Як ми знаходимо топ‑менеджерів
          </h2>
        </motion.div>

        {/* Desktop timeline */}
        <div className="hidden md:block relative" data-id="element-1040">
          {/* Center line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-primary-200 via-primary-300 to-primary-100 -translate-x-1/2" data-id="element-1041" />

          <div className="space-y-12" data-id="element-1042">
            {steps.map((step, i) => <motion.div key={step.num} initial={{
            opacity: 0,
            y: 24
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className={`relative flex items-center gap-8 ${step.side === 'right' ? 'flex-row-reverse' : ''}`} data-id="element-1043">
                {/* Content card */}
                <div className="w-[calc(50%-2.5rem)]" data-id="element-1044">
                  <div className={`p-6 rounded-2xl bg-navy-50/70 border border-navy-100 ${step.side === 'right' ? 'text-right' : ''}`} data-id="element-1045">
                    <h3 className="text-lg font-bold text-navy-900 mb-2" data-id="element-1046">
                      {step.title}
                    </h3>
                    <p className="text-sm text-navy-500 leading-relaxed" data-id="element-1047">
                      {step.desc}
                    </p>
                  </div>
                </div>

                {/* Center node */}
                <div className="absolute left-1/2 -translate-x-1/2 flex items-center justify-center w-14 h-14 rounded-full bg-white border-2 border-primary-300 shadow-lg shadow-primary-100/50 z-10" data-id="element-1048">
                  <span className="text-sm font-extrabold text-primary-600" data-id="element-1049">
                    {step.num}
                  </span>
                </div>

                {/* Empty side */}
                <div className="w-[calc(50%-2.5rem)]" data-id="element-1050" />
              </motion.div>)}
          </div>
        </div>

        {/* Mobile timeline */}
        <div className="md:hidden relative pl-10" data-id="element-1051">
          <div className="absolute left-4 top-0 bottom-0 w-px bg-gradient-to-b from-primary-200 via-primary-300 to-primary-100" data-id="element-1052" />
          <div className="space-y-8" data-id="element-1053">
            {steps.map((step, i) => <motion.div key={step.num} initial={{
            opacity: 0,
            x: -16
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="relative" data-id="element-1054">
                <div className="absolute -left-10 top-4 flex items-center justify-center w-8 h-8 rounded-full bg-white border-2 border-primary-300 shadow-md z-10" data-id="element-1055">
                  <span className="text-[10px] font-extrabold text-primary-600" data-id="element-1056">
                    {step.num}
                  </span>
                </div>
                <div className="p-5 rounded-2xl bg-navy-50/70 border border-navy-100" data-id="element-1057">
                  <h3 className="text-base font-bold text-navy-900 mb-1.5" data-id="element-1058">
                    {step.title}
                  </h3>
                  <p className="text-sm text-navy-500 leading-relaxed" data-id="element-1059">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}
function CtaBanner() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5
  }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1060">
      <div className="p-8 sm:p-12 rounded-3xl bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 relative overflow-hidden" data-id="element-1061">
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-primary-500/10 blur-3xl" data-id="element-1062" />
        <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-primary-400/10 blur-3xl" data-id="element-1063" />
        <div className="relative z-10 flex flex-col sm:flex-row items-center gap-6 sm:gap-10" data-id="element-1064">
          <div className="flex-1" data-id="element-1065">
            <h3 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight" data-id="element-1066">
              Потрібен C‑level керівник?
            </h3>
            <p className="mt-2 text-navy-300 leading-relaxed" data-id="element-1067">
              Розкажіть про вашу задачу — ми зв'яжемося протягом 2 годин та
              запропонуємо план дій.
            </p>
          </div>
          <a href="#contact" className="flex-shrink-0 inline-flex items-center gap-2 px-7 py-4 text-base font-semibold text-navy-900 bg-white rounded-xl hover:bg-navy-50 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-1068">
            Залишити заявку
            <ArrowRightIcon className="w-4 h-4" data-id="element-1069" />
          </a>
        </div>
      </div>
    </motion.div>;
}
export function ExecutiveSearchPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-1070">
      <Header data-id="element-1071" />
      <main className="pt-16 lg:pt-20" data-id="element-1072">
        <HeroSection data-id="element-1073" />
        <WhatWeDoSection data-id="element-1074" />
        <PositionsSection data-id="element-1075" />
        <ProcessSection data-id="element-1076" />
        <CtaBanner data-id="element-1077" />
        <div id="contact" data-id="element-1078">
          <ContactForm data-id="element-1079" />
        </div>
      </main>
      <Footer data-id="element-1080" />
    </div>;
}